import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, take, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AtlasDataService } from '../../core/src/data.service';
import { PamDialogService } from './pam-dialog/pam-dialog.service';

@Injectable()
export class PamInterceptor implements HttpInterceptor {
  private readonly atlasDataService = inject(AtlasDataService);
  private readonly pamDialogService = inject(PamDialogService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        return error.status === 403
          ? this.atlasDataService.showPamDialog$.pipe(
              take(1),
              switchMap((showPamDialog) => {
                if (showPamDialog) {
                  this.pamDialogService.openDialog();
                }
                return throwError(() => error);
              }),
            )
          : throwError(() => error);
      }),
    );
  }
}
